<template>
  <div>
    <div class="row">
      <div class="col">
        <TextLabel>
          {{
            $t(
              '_web_tournament_settings_autoprocess_tournament',
              'Automatically process a tournament'
            )
          }}
        </TextLabel>
      </div>
    </div>
    <div class="row">
      <div class="col mb-3">
        <TextBlock variant="secondary">
          {{
            $t(
              '_web_tournament_additional_settings_autoprocess_tournament-help',
              'System automatycally qualifies participants, builds and publish brackets, starts a tournament once registration is closed'
            )
          }}
        </TextBlock>
      </div>
    </div>
    <div class="row">
      <HeraFormSwitch
        v-model="autoprocessTournament"
        class="col-auto"
        :disabled="isTournamentFieldDisabled('autoprocessTournament')"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import TextLabel from '@/components/atoms/TextLabel';
import TextBlock from '@/components/atoms/TextBlock';
import HeraFormSwitch from '@/components/atoms/form/HeraFormSwitch';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentAutoprocessingSetting',
  components: {
    TextLabel,
    TextBlock,
    HeraFormSwitch,
  },
  mixins: [translate('_web_tournament_additional_settings')],
  computed: {
    ...mapGetters(['currentTournament', 'isTournamentFieldDisabled']),
    autoprocessTournament: {
      get() {
        return this.$lodash.get(
          this.currentTournament,
          'schedule.auto_activation_mode',
          null
        );
      },
      set(val) {
        this.updateCurrentTournament({
          auto_activation_mode: val,
          component: 'schedule',
        });
      },
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
  },
};
</script>
